import { formatUIDateTime } from 'utils/helpers'

export const toTableRowItems = items =>
  items.map(item => ({
    id: item.id,
    deliveryStatus: item.deliveryStatus || '',
    deliveryStatusValue: item.deliveryStatusValue || '',
    createdBy: item.createdBy || '',
    created: formatUIDateTime(item.created),
    updatedBy: item.updatedBy || '',
    updated: formatUIDateTime(item.updated)
  }))
